import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const buttonOpen = document.getElementById( 'navBar-open' );
const buttonClose = document.getElementById( 'navBar-close' );

const navbar = document.getElementById( 'navBar-wrapper' );

function openNav() {
	navbar.setAttribute( 'aria-hidden', false );
	document.documentElement.classList.toggle( 'is-open' );
	disableBodyScroll( navbar );
}

function closeNav() {
	navbar.setAttribute( 'aria-hidden', true );
	document.documentElement.classList.toggle( 'is-open' );
	enableBodyScroll( navbar );
}

function init() {
	buttonOpen.addEventListener( 'click', openNav );
	buttonClose.addEventListener( 'click', closeNav );
}

export default {
	init,
};
